import { setPageStateById } from '@/contexts/PageContext/PageContext';

export const setShowLeftMenu = (setState: setPageStateById) => (value: boolean) => {
  localStorage.setItem('left_menu', value.toString());
  setState('SET_SHOW_LEFT_MENU', (s) => ({
    ...s,
    showLeftMenu: value,
  }));
};
